import { instance, errorService, savePreviousData } from '@/services/api'
import { dropdownAPIs, projectAPIs } from '@/services/authConstantsV1'
import { calculateHeight, showNotification } from '@/services/calculate'
import {
  formatKeys,
  socketEvents,
  checkLinkAssetEvents,
  checkAssetDetailsEvents,
  validateNumber,
  tableName,
} from '@/services/config'
import { updateGridRecord } from '@/services/grid'
import { formatValue, timeConvert } from '@/services/convert'
import { AgGridVue } from 'ag-grid-vue'
import _ from 'lodash'
import ActionRenderer from '@/components/DynamicComponents/Renderers/actionRendere'
import CurrencyRenderer from '@/components/DynamicComponents/Renderers/currencyRenderer'
import LinkEditor from '@/components/DynamicComponents/Renderers/linkRendere'
import SelectEditor from '@/components/DynamicComponents/Renderers/dropdownEditor'
import InputEditor from '@/components/DynamicComponents/Renderers/inputEditor'
import datePickerInput from '@/components/DynamicComponents/Renderers/datePickerRender'
import dateRenderer from '@/components/DynamicComponents/Renderers/dateRenderer'
import InputNumberEditor from '@/components/DynamicComponents/Renderers/inputNumberEditor'
import CheckBoxEditor from '@/components/DynamicComponents/Renderers/checkboxRender'
import CustomFilter from '@/components/DynamicComponents/Renderers/customFilter'
import ToolTipRenderer from '@/components/DynamicComponents/Renderers/tooltipRenderer'
import NumberRender from '@/components/DynamicComponents/Renderers/numberRenderer'
import RadioButtonRender from '@/components/DynamicComponents/Renderers/radioButtonRender'
import LinkAsset from '@/components/DynamicComponents/Projects/LinkAsset'
import RoundOffCurrencyRenders from '@/components/DynamicComponents/Renderers/roundOffCurrencyRenders'

export default {
  components: {
    'ag-grid-vue': AgGridVue,
    'link-asset': LinkAsset,
  },
  props: [
    'component',
    'dropdownData',
    'screenIndentifier',
    'columnSettings',
    'taxLifeMode',
    'assetClassMode',
    'projectData',
  ],
  data() {
    return {
      formLayout: 'horizontal',
      currency: null,
      savePreviousData: savePreviousData,
      data: [],
      loaderClone: false,
      selectedRowKeys: [],
      loadingTable: false,
      fieldLoader: false,
      loadingData: false,
      fieldName: '',
      assetsNo: undefined,
      form: {
        id: undefined,
        city: undefined,
        clientId: undefined,
        clientName: undefined,
        columnsDetails: undefined,
        entityName: undefined,
        locationFactor: undefined,
        projectManager: undefined,
        projectName: undefined,
        projectNumber: undefined,
        projectReviewer: undefined,
        projectStaffEngineer: undefined,
        state: undefined,
        streetAddress: undefined,
        zipcode: null,
        previousProjectNumber: undefined,
        percentComplete: undefined,
        timeSpent: 0,
        projectTimeLogs: [],
        taxYearEnd: undefined,
      },
      rulesformProject: {
        projectNumber: [
          {
            required: true,
            message: 'Please enter project number',
            trigger: 'blur',
          },
        ],
        locationFactor: [
          {
            required: true,
            message: 'Please enter location factor',
            trigger: 'blur',
          },
        ],
        taxYearEnd: [
          {
            required: true,
            message: 'Please enter Tax Year Filing',
            trigger: 'blur',
          },
        ],
      },
      gridOptions: {
        alwaysShowVerticalScroll: true,
        debounceVerticalScrollbar: true,
        alwaysShowHorizontalScroll: true,
        headerHeight: 30,
        rowHeight: 28,
        suppressRowClickSelection: true,
        singleClickEdit: true,
        stopEditingWhenGridLosesFocus: false,
        tooltipShowDelay: 0,
        defaultColDef: {
          sortable: true,
          resizable: true,
          editable: true,
          suppressMovable: true,
          menuTabs: ['filterMenuTab'],
        },
      },
      width: '100%',
      height: '430px',
      frameworkComponents: null,
      close: false,
      roleDropdown: {
        managers: [],
        reviewers: [],
        staffs: [],
      },
      columns: [],
      loaderAdd: false,
      templates: [],
      loader: false,
      visible: false,
      tempArrayList: {
        managers: [],
        reviewers: [],
        staffs: [],
      },
      cardHeight: '375px',
      closable: true,
      visibleClone: false,
      visibleAsset: false,
      formAsset: {
        id: undefined,
        assetNumber: undefined,
        analysisType: undefined,
        analysisTypeId: undefined,
        structureProfile: undefined,
        structureProfileId: undefined,
        buildingUse: undefined,
        buildingUseId: undefined,
        template: undefined,
        description: undefined,
        sf: undefined,
        pis: undefined,
        costBasis: undefined,
      },
      linkAssetDetails: null,
      projectDetails: null,
      sidebar: {
        taxLifeMode: _.get(this, 'taxLifeMode', []),
        assetClassMode: _.get(this, 'assetClassMode', []),
      },
      isArchive: false,
    }
  },
  computed: {
    formItemLayout() {
      const { formLayout } = this
      return formLayout === 'horizontal'
        ? {
          labelCol: { span: 2 },
          wrapperCol: { span: 4 },
        }
        : {}
    },
  },
  beforeMount() {
    const settings = JSON.parse(localStorage.getItem('userSettings'))
    this.currency = settings.currency
    this.isArchive = JSON.parse(sessionStorage.getItem('Is-Archive'))
    if (!this.isArchive) {
      this.isArchive = this.projectData.archiveStatus === 'QUEUED'
    }
    this.getAssets()
    this.getProjectDetails()
    if (!this.isArchive) {
      this.getUserRoles()
      this.getBuildingUses()
    }

    this.loadingConfig()
  },
  beforeDestroy() {
    this.$socketHub.$off('message-received')
  },
  mounted() {
    this.height = calculateHeight('projectDetailsTable', true)
    this.$root.$off('updateAssetsDetails')
    this.$root.$on('updateAssetsDetails', this.onUpdateAssets)
    this.$root.$off('applyTemplate')
    this.$root.$on('applyTemplate', this.onUpdateTemplate)
    this.$root.$off('deleteAsset')
    this.$root.$on('deleteAsset', this.deleteAsset)
    this.$root.$off('openLinkData')
    this.$root.$on('openLinkData', this.openLinkData)
    this.$root.$off('unlinkAsset')
    this.$root.$on('unlinkAsset', this.linkUnlinkAsset)
    this.$socketHub.$on('message-received', this.messageReceived)
    this.$root.$off('saveAsTemplate')
    this.$root.$on('saveAsTemplate', this.openAsset)
    this.$root.$off('addLevel')
    this.$root.$off('orderingTiles')
    this.$root.$off('onUpdateTakeoff')
    this.$root.$off('onCloneTakeoff')
    this.$root.$off('onDeleteTakeoff')
  },
  watch: {
    taxLifeMode() {
      this.sidebar.taxLifeMode = this.taxLifeMode
      this.sidebar.assetClassMode = this.assetClassMode
    },
  },
  methods: {
    // Grid Column Section Start //
    loadingConfig() {
      this.frameworkComponents = {
        actionCellRenderer: ActionRenderer,
        costPriceCellRenderer: CurrencyRenderer,
        inputCellEditor: InputEditor,
        selectEditor: SelectEditor,
        datePickerInput: datePickerInput,
        dateRenderer: dateRenderer,
        inputNumberEditor: InputNumberEditor,
        linkEditor: LinkEditor,
        checkBoxEditor: CheckBoxEditor,
        customFilter: CustomFilter,
        toolTipRenderer: ToolTipRenderer,
        numberRender: NumberRender,
        RadioButtonRender: RadioButtonRender,
        roundOffCurrencyRenders: RoundOffCurrencyRenders,
      }
      this.columns = [
        {
          field: 'checkbox',
          checkboxSelection: false,
          floatingFilter: false,
          width: 5,
          cellRenderer: 'RadioButtonRender',
          suppressSizeToFit: true,
          resizable: true,
          editable: false,
          multiSelect: false,
          pinned: 'left',
          sortable: false,
          menuTabs: [],
          hide: this.isArchive,
        },
        {
          headerName: 'Asset / Building #',
          field: 'assetNumber',
          width: 100,
          cellEditor: 'inputNumberEditor',
          cellStyle: { textAlign: 'center' },
          headerClass: 'header-center',
          headerTooltip: 'Asset / Building #',
          filter: 'customFilter',
          cellRendererParams: {
            type: 'projectDetails',
            placeholder: 'assetNumber',
            precision: 0,
            min: 0,
          },
          cellRenderer: 'toolTipRenderer',
          editable: !this.isArchive,
        },
        {
          headerName: 'Analysis Type',
          field: 'analysisType',
          width: 200,
          headerTooltip: 'Analysis Type',
          filter: 'customFilter',
          cellEditor: 'selectEditor',
          cellRendererParams: {
            type: 'projectDetails',
            dropdownName: 'analysisType',
            dropdownData: this.dropdownData,
          },
          cellRenderer: 'toolTipRenderer',
          editable: !this.isArchive,
        },
        {
          headerName: 'Structure Profile',
          field: 'structureProfile',
          width: 120,
          headerTooltip: 'Structure Profile',
          filter: 'customFilter',
          cellEditor: 'selectEditor',
          cellRendererParams: {
            type: 'projectDetails',
            dropdownName: 'structureProfile',
            dropdownData: this.dropdownData,
            name: 'structureProfile',
          },
          editable: params => {
            return !params.data.linkMethod && !this.isArchive
          },
          cellRenderer: 'toolTipRenderer',
        },
        {
          headerName: 'Building Use',
          field: 'buildingUse',
          width: 120,
          headerTooltip: 'Building Use',
          filter: 'customFilter',
          cellEditor: 'selectEditor',
          cellRendererParams: {
            type: 'projectDetails',
            dropdownName: 'tempBuildingUse',
            dropdownData: this.dropdownData,
          },
          cellRenderer: 'toolTipRenderer',
          editable: !this.isArchive,
        },
        {
          headerName: 'Template',
          field: 'template',
          width: 120,
          headerTooltip: 'Template',
          filter: 'customFilter',
          cellEditor: 'selectEditor',
          cellRendererParams: {
            type: 'projectDetails',
            dropdownName: 'template',
            dropdownData: this.dropdownData,
            templates: this.dropdownData.template,
            sidebar: this.sidebar,
          },
          cellRenderer: 'toolTipRenderer',
          editable: !this.isArchive,
        },
        {
          headerName: 'Description / Asset Name',
          field: 'description',
          width: 250,
          filter: 'customFilter',
          cellEditor: 'inputCellEditor',
          headerTooltip: 'Description / Asset Name',
          cellRendererParams: { type: 'projectDetails' },
          cellRenderer: 'toolTipRenderer',
          editable: !this.isArchive,
        },
        {
          headerName: 'SF',
          field: 'sf',
          cellStyle: { textAlign: 'right' },
          headerClass: 'header-right',
          width: 80,
          filter: 'customFilter',
          cellEditor: 'inputNumberEditor',
          headerTooltip: 'SF',
          cellRendererParams: {
            type: 'projectDetails',
            placeholder: 'SF',
            precision: 0,
            min: 0,
            max: 999999,
          },
          cellRenderer: 'numberRender',
          editable: !this.isArchive,
        },
        {
          headerName: 'PIS',
          field: 'pis',
          width: 150,
          filter: 'customFilter',
          cellStyle: { textAlign: 'center' },
          headerClass: 'header-center',
          cellEditor: 'datePickerInput',
          cellRenderer: 'dateRenderer',
          cellRendererParams: {
            type: 'projectDetails',
            dropdownData: this.dropdownData,
          },
          editable: !this.isArchive,
        },
        {
          headerName: 'Cost Basis',
          field: 'costBasis',
          cellStyle: { textAlign: 'right' },
          headerClass: 'header-right',
          width: 120,
          filter: 'customFilter',
          cellEditor: 'inputNumberEditor',
          cellRenderer: 'roundOffCurrencyRenders',
          headerTooltip: 'Cost Basis',
          cellRendererParams: {
            type: 'projectDetails',
            placeholder: 'Cost Basis',
            precision: 2,
            min: 0,
            max: 999999999,
          },
          editable: !this.isArchive,
        },
        {
          headerName: 'Link',
          field: 'link',
          cellRenderer: 'linkEditor',
          valueGetter: params => {
            return params.data.costBasis && !params.data.link && params.data.sf
              ? 'Link'
              : params.data.link
          },
          width: 120,
          sortable: false,
          editable: false,
          headerTooltip: 'link',
          tooltipField: 'link',
          floatingFilter: false,
          cellRendererParams: { type: 'projectDetails' },
          menuTabs: [],
        },
        {
          headerName: 'Action',
          field: 'action',
          cellRenderer: 'actionCellRenderer',
          cellStyle: { textAlign: 'right' },
          headerClass: 'header-center',
          cellRendererParams: { type: 'projectDetails' },
          width: 80,
          suppressSizeToFit: true,
          headerTooltip: 'Action',
          sortable: false,
          editable: false,
          floatingFilter: false,
          pinned: 'right',
          menuTabs: [],
          hide: this.isArchive,
        },
      ]
    },
    // Grid Column Section End //

    // Project Details Section Start //
    getProjectDetails() {
      this.loadingData = true
      instance
        .get(projectAPIs.project.details(this.$route.params.id))
        .then(res => {
          this.form = formatKeys(_.get(res.data, 'result', null), this.form)
          window.oldForm = { ...this.form }
          this.loadingData = false
          this.form.locationFactor = this.form.locationFactor
            ? this.form.locationFactor.toFixed(3)
            : undefined
          const element = document.querySelector('#' + 'projectdetails')
          if (element) {
            this.height =
              Math.round(element.getBoundingClientRect().height) - 126 + 'px'
          }
          this.form.timeSpent = timeConvert(
            _.get(this.form, 'projectTimeLogs', []).reduce((total, item) => {
              return total + (item.timeSpent || 0)
            }, 0),
          )
          this.form.projectTimeLogs = _.get(
            this.form,
            'projectTimeLogs',
            [],
          ).map(value => {
            value.timeSpent = timeConvert(value.timeSpent)
            return value
          })
          this.cardHeight = calculateHeight('projectDetails', true)
        })
        .catch(err => {
          this.loadingData = false
          errorService(err)
        })
    },

    onUpdate(fieldName, value) {
      let isValid = true
      switch (fieldName) {
        case 'projectNumber':
          isValid = validateNumber(value, fieldName, 'Project Number')
          if (!isValid) {
            this.form.projectNumber = window.oldForm[fieldName]
          }
          break
        case 'locationFactor':
          isValid = validateNumber(value, fieldName, 'Location Factor')
          if (isValid) {
            this.form.locationFactor = parseFloat(this.form.locationFactor)
              .toFixed(3)
              .toString()
          } else {
            this.form.locationFactor = window.oldForm[fieldName]
          }
          break
        default:
          break
      }
      this.$refs[fieldName].onFieldBlur()
      const currentValue = !value ? '' : value
      const previousValue = !window.oldForm[fieldName]
        ? ''
        : window.oldForm[fieldName]
      if (previousValue.toString() !== currentValue.toString() && isValid) {
        this.fieldLoader = true
        this.fieldName = fieldName
        const request = {
          [fieldName]: value || null,
        }
        instance
          .patch(projectAPIs.project.details(this.$route.params.id), request)
          .then(response => {
            const result = _.get(response.data, 'result', null)
            this.fieldLoader = false
            this.fieldName = undefined
            switch (fieldName) {
              case 'projectNumber':
                this.form.projectNumber = value
                this.form.projectTimeLogs = []
                this.form.timeSpent = timeConvert(
                  _.get(result, 'projectTimeLogs', []).reduce((total, item) => {
                    return total + (item.timeSpent || 0)
                  }, 0),
                )
                this.form.projectTimeLogs = _.get(
                  result,
                  'projectTimeLogs',
                  [],
                ).map(value => {
                  value.timeSpent = timeConvert(value.timeSpent)
                  return value
                })
                break
              case 'projectName':
                this.$root.$emit('updateProjectName', value)
                break
              case 'zipcode':
                this.getLocationFactorByZipCode()
                break

              default:
                break
            }
            window.oldForm[fieldName] = value
          })
          .catch(err => {
            this.fieldLoader = false
            this.fieldName = undefined
            errorService(err)
          })
      }
    },

    getLocationFactorByZipCode() {
      if (this.form.zipcode && this.form.zipcode.length > 2) {
        instance
          .get(dropdownAPIs.locationFactor(this.form.zipcode.slice(0, 3)))
          .then(response => {
            if (!response.data.message) {
              this.form.locationFactor = _.get(
                response.data,
                'result.locationFactor',
                [],
              )
              this.onUpdate(
                'locationFactor',
                this.form.locationFactor,
                'Location Factor',
              )
            } else {
              showNotification('error', 'Location Factor', 'No records found!')
            }
          })
          .catch(error => {
            errorService(error)
          })
      }
    },

    syncProject(event) {
      event.stopPropagation()
      this.loader = true
      instance
        .post(projectAPIs.project.sync(this.$route.params.id), {
          projectNumber: formatValue(this.form.projectNumber, 0),
        })
        .then(response => {
          showNotification(
            'info',
            'Sync Project Details',
            _.get(response.data, 'message', null),
          )
          this.loader = false
        })
        .catch(error => {
          this.loader = false
          errorService(error)
        })
    },

    updateSyncProject(data) {
      this.form.projectNumber = data.ProjectNumber
      this.form.clientId = data.ClientId
      this.form.clientName = data.ClientName
      this.form.projectName = data.ProjectName
      this.form.streetAddress = data.StreetAddress
      this.form.city = data.City
      this.form.state = data.State
      this.form.zipcode = data.Zipcode ? Number(data.Zipcode) : data.Zipcode
      this.form.projectManager = data.ProjectManager
      this.form.projectReviewer = data.ProjectReviewer
      this.form.projectStaffEngineer = data.ProjectStaffEngineer
      this.form.entityName = data.EntityName
      this.form.locationFactor = data.LocationFactor
        ? data.LocationFactor.toFixed(3)
        : data.LocationFactor
      this.form.percentComplete = data.PercentComplete
        ? data.PercentComplete.toFixed(2)
        : data.PercentComplete
      this.$root.$emit('updateProjectName', this.form.projectName)
      window.oldForm = { ...this.form }
    },
    // Project Details Section End //

    // Project Dropdown Section Start //
    getUserRoles() {
      instance
        .post(dropdownAPIs.userRoles, [2, 4, 7])
        .then(response => {
          const data = _.get(response.data, 'result', [])
          this.tempArrayList.managers = data.find(i => i.role_Id === 2).users
          this.tempArrayList.reviewers = data.find(i => i.role_Id === 4).users
          this.tempArrayList.staffs = data.find(i => i.role_Id === 7).users
        })
        .catch(error => {
          errorService(error)
        })
    },

    getBuildingUses() {
      const structureProfileList = _.get(
        this.dropdownData,
        'structure_profile',
        [],
      )
      Object.assign(this.dropdownData, { tempBuildingUse: [] })
      structureProfileList.forEach(element => {
        this.getBuildingUse(element.id, element.option)
      })
    },

    getBuildingUse(value, name) {
      instance
        .post(dropdownAPIs.dropdown, { building_use: value })
        .then(response => {
          const result = _.get(response.data.result, 'building_use', [])
          result.forEach(element => {
            this.dropdownData.tempBuildingUse.push({
              id: element.id,
              option: element.option,
              value: element.value,
              structureProfileId: value,
              structureName: name,
            })
          })
        })
        .catch(error => {
          errorService(error)
        })
    },

    getTemplates() {
      instance
        .get(dropdownAPIs.templates)
        .then(response => {
          this.columns.map(element => {
            if (element.field === 'template') {
              element.cellRendererParams.templates = _.get(
                response.data,
                'result',
                [],
              )
            }
            return element
          })
          Object.assign(this.dropdownData, {
            template: _.get(response.data, 'result', []),
          })
        })
        .catch(error => {
          errorService(error)
        })
    },

    onSearch(searchText, type) {
      this.roleDropdown[type] = !searchText
        ? []
        : this.filterArray(searchText, type)
    },

    filterArray(searchText, type) {
      const list = []
      this.tempArrayList[type].forEach(element => {
        if (
          element.name
            .toString()
            .toUpperCase()
            .indexOf(searchText.toUpperCase()) > -1
        ) {
          list.push(String(element.name))
        }
      })
      return list
    },
    // Project Dropdown Section Start //

    // Grid Methods Section Start //
    getData(params) {
      this.columns.map(col => {
        if (col.field === 'cost_Basis') {
          col['editable'] = params => {
            return (
              (!params.data.link || params.data.link === 'Link') &&
              !this.isArchive
            )
          }
        }
      })
      this.getColumnSettings(params)
      params.api.setRowData(this.data)
    },

    onModelUpdated() {
      if (
        this.gridOptions.api &&
        this.gridOptions.api.rowModel.rowsToDisplay.length === 0
      ) {
        this.gridOptions.api.showNoRowsOverlay()
      }
      if (
        this.gridOptions.api &&
        this.gridOptions.api.rowModel.rowsToDisplay.length > 0
      ) {
        this.gridOptions.api.hideOverlay()
      }
    },

    onRowSelected(event) {
      const selectedNodes = this.gridOptions.api.getSelectedNodes()
      const selectedData = selectedNodes.map(node => node.data.id)
      this.selectedRowKeys = selectedData
    },

    onSelectionChanged(event) {
      const selectedNodes = this.gridOptions.api.getSelectedNodes()
      const selectedData = selectedNodes.map(node => node.data.id)
      this.selectedRowKeys = selectedData
      this.enableDeleteClone = selectedData.length > 0
    },
    // Grid Methods Section Start //

    // Asset Section Start //
    getAssets() {
      this.closable = true
      this.loadingTable = true
      instance
        .get(projectAPIs.project.asset.assets(this.$route.params.id))
        .then(res => {
          this.loadingTable = false
          this.data = _.get(res.data, 'result', [])
          this.data.forEach(element => {
            Object.assign(element, {
              isChildLink: this.data.some(i => i.linkedAssetId === element.id),
            })
          })
          this.gridOptions.api.setRowData(this.data)
          this.gridOptions.api.redrawRows()
          this.$root.$emit('updateNavigation', this.data)
        })
        .catch(err => {
          this.loadingTable = false
          errorService(err)
        })
    },

    addAssets() {
      this.loaderAdd = true
      const req = {
        assetCount: this.assetsNo ? this.assetsNo : 1,
      }
      instance
        .post(projectAPIs.project.asset.add(this.$route.params.id), req)
        .then(res => {
          this.loaderAdd = false
          showNotification(
            'success',
            'Success',
            `${this.assetsNo ? this.assetsNo : 1} new ${
              this.assetsNo && this.assetsNo > 1 ? 'assets' : 'asset'
            } added!`,
          )
          let newData = []
          newData = newData.concat(_.get(res.data, 'result', []))
          newData.forEach(element => {
            Object.assign(element, {
              isChildLink: newData.some(i => i.linkedAssetId === element.id),
            })
          })
          this.gridOptions.api.setRowData(newData)
          this.assetsNo = undefined
          this.gridOptions.api.setFocusedCell(this.data.length, 'analysisType')
          this.gridOptions.api.startEditingCell({
            rowIndex: this.data.length,
            colKey: 'analysisType',
          })
          this.data = []
          this.data = newData
        })
        .catch(err => {
          this.loaderAdd = false
          errorService(err)
        })
    },

    cloneAssets(type) {
      this.loaderClone = true
      this.closable = false
      const url = projectAPIs.project.asset.clone(
        this.$route.params.id,
        this.selectedRowKeys[0],
      )
      instance
        .post(url, {
          assetCount: this.assetsNo ? this.assetsNo : 1,
          cloneTakeoffs: type,
        })
        .then(res => {
          showNotification('info', 'Please wait while updating data')
          this.selectedRowKeys = []
          this.assetsNo = undefined
        })
        .catch(err => {
          this.loaderClone = false
          this.visibleClone = false
          this.closable = true
          errorService(err)
        })
    },

    deleteAsset(record) {
      var that = this
      this.$confirm({
        title: `Are you sure want to delete this row?`,
        content: h => (
          <div style="color:red">
            <p>
              This action will delete all information related to this asset.
            </p>
            <p>Please confirm.</p>
          </div>
        ),
        onOk() {
          that.confirmDelete(record)
        },
        onCancel() {},
        class: 'test',
      })
    },

    onUpdateTemplate(value, record, key, index, data, keyCode, isCheck) {
      if (
        this.sidebar.taxLifeMode.length > 0 ||
        this.sidebar.assetClassMode.length > 0
      ) {
        this.projectDetails = { ...record }
        let isAllocatedCost = false
        let assetDetails = this.sidebar.taxLifeMode.find(
          i => i.name === record.description,
        )
        if (assetDetails) {
          isAllocatedCost = assetDetails.assetDetails.some(
            i => i.allocatedCost > 0,
          )
        }
        if (!isAllocatedCost) {
          assetDetails = this.sidebar.assetClassMode.find(
            i => i.name === record.description,
          )
          if (assetDetails) {
            isAllocatedCost = assetDetails.assetDetails.some(
              i => i.allocatedCost > 0,
            )
          }
        }
        if (isCheck && isAllocatedCost) {
          var that = this
          this.$confirm({
            title: `Are you sure want to change template?`,
            content: h => (
              <div style="color:red">
                <p>
                  This action will delete all tenants and data related to this
                  asset:{'  '}
                  {record.description || record.assetNumber}.
                </p>
                <p>Please confirm.</p>
              </div>
            ),
            onOk() {
              that.onUpdateAssets(value, record, key, index, data, keyCode)
            },
            onCancel() {
              setTimeout(() => {
                that.resetRowData(index)
              }, 100)
            },
          })
        } else {
          this.onUpdateAssets(value, record, key, index, data, keyCode)
        }
      }
    },

    onUpdateAssets(value, record, key, index, data, keyCode) {
      const currentValue =
        !value || value === null || value === '' ? null : value.toString()
      const previousValue =
        !window.previousValue || window.previousValue === null
          ? null
          : window.previousValue.toString()
      if (previousValue !== currentValue) {
        let request = null
        let isValid = true
        switch (key) {
          case 'assetNumber':
          case 'description':
            this.projectDetails = { ...record }
            request = {
              [key]: value || null,
            }
            break
          case 'sf':
            this.projectDetails = { ...record }
            isValid = validateNumber(value, key, 'SF')
            if (isValid) {
              request = {
                [key]: value || null,
              }
            }
            break
          case 'costBasis':
            this.projectDetails = { ...record }
            isValid = validateNumber(value, key, 'Cost Basis')
            if (isValid) {
              request = {
                [key]: value || 0,
              }
              this.$root.$emit(
                'popupUpdation',
                true,
                true,
                `Please wait while updating cost basis`,
              )
            }
            break
          case 'analysisType':
            this.projectDetails = { ...record }
            request = {
              [key]: !value || value === 'none' ? null : value,
              analysisTypeId: data ? data.id : null,
              structureProfile: null,
              structureProfileId: null,
              buildingUseId: null,
              buildingUse: null,
            }
            if (record.analysisType) {
              Object.assign(request, {
                templateId: 0,
                template: null,
              })
            }
            break
          case 'structureProfile':
            this.projectDetails = { ...record }
            request = {
              [key]: !value || value === 'none' ? null : value,
              structureProfileId: data ? data.id : null,
              buildingUseId: null,
              buildingUse: null,
            }
            if (record.structureProfile) {
              Object.assign(request, {
                templateId: 0,
                template: null,
              })
            }
            break
          case 'buildingUse':
            this.projectDetails = { ...record }
            request = {
              [key]: !value || value === 'none' ? null : value,
              buildingUseId: data ? data.id : null,
            }
            if (record.buildingUse) {
              Object.assign(request, {
                templateId: 0,
                template: null,
              })
            }
            break
          case 'template':
            this.projectDetails = { ...record }
            request = {
              [key]: !value || value === 'none' ? null : value,
              templateId: !value || value === 'none' ? 0 : data ? data.id : null,
            }
            this.$root.$emit(
              'popupUpdation',
              true,
              true,
              'Please wait while template integrating...',
            )
            break
          case 'pis':
            this.projectDetails = { ...record }
            if (value && value !== 'Invalid date') {
              if (keyCode !== 9 && keyCode !== 13) {
                this.gridOptions.api.stopEditing()
              }
              this.gridOptions.api.startEditingCell({
                rowIndex: index,
                colKey: 'costBasis',
              })
              this.loadingTable = true
            } else if (value && value === 'Invalid date') {
              isValid = false
              showNotification('error', 'Please enter proper date format')
              this.gridOptions.api.stopEditing()
              this.gridOptions.api.setFocusedCell(index, key)
              this.gridOptions.api.startEditingCell({
                rowIndex: index,
                colKey: key,
              })
            }
            request = {
              [key]: value || 0,
            }
            this.$root.$emit(
              'popupUpdation',
              true,
              true,
              `Please wait while updating PIS date`,
            )
            break

          default:
            break
        }
        if (isValid) {
          instance
            .patch(
              projectAPIs.project.asset.update(
                this.$route.params.id,
                record.id,
              ),
              request,
            )
            .then(response => {
              const newData = [...this.data]
              newData[index] = _.get(response.data, 'result', null)
              if (key === 'description') {
                const ids = newData
                  .filter(i => i.linkedAssetId === record.id)
                  .map(x => x.id)
                if (ids.length > 0) {
                  ids.forEach(element => {
                    const assetIndex = newData.findIndex(i => i.id === element)
                    if (assetIndex > -1) {
                      newData[assetIndex].link = value
                    }
                  })
                }
              }
              newData[index].isChildLink = this.data.some(
                i => i.linkedAssetId === record.id,
              )
              this.data = [...newData]
              this.gridOptions.api.redrawRows()
              const itemsToUpdate = updateGridRecord(
                this.gridOptions,
                record,
                newData[index],
              )
              this.gridOptions.api.applyTransaction({ update: itemsToUpdate })
              this.gridOptions.api.redrawRows()
              this.setActiveCell(key, index, value, record)
            })
            .catch(err => {
              this.loadingTable = false
              errorService(err)
              this.resetRowData(index)
            })
        } else {
          this.$root.$emit('popupUpdation', false, true, null)
          this.resetRowData(index)
        }
      } else {
        if (keyCode === 9) {
          this.gridOptions.api.tabToNextCell()
        }
      }
    },

    confirmDelete(record) {
      this.loadingTable = true
      instance
        .delete(projectAPIs.project.asset.delete(this.$route.params.id), {
          data: [record.id],
        })
        .then(response => {
          showNotification(
            'success',
            'Delete Asset',
            _.get(response.data, 'message', 'Asset Deleted Successfully!'),
          )
          const index = this.data.findIndex(val => val.id === record.id)
          if (index > -1) {
            this.data.splice(index, 1)
          }
          this.gridOptions.api.applyTransaction({
            remove: [record],
          })
          this.$root.$emit('removeAsset', record.id)
          this.loadingTable = false
          this.selectedRowKeys = []
          this.$root.$emit('updateNavigation', this.data)
        })
        .catch(error => {
          this.loadingTable = false
          errorService(error)
        })
    },

    openAsset(data) {
      this.formAsset = formatKeys(data, this.formAsset)
      this.formAsset.description = this.formAsset.description
        ? `${this.formAsset.description} - Copy`
        : 'Copy'
      this.visibleAsset = true
    },

    saveAssetAsTemplate() {
      this.loaderClone = true
      this.closable = false
      const url = projectAPIs.project.asset.saveAsTemplate(
        this.$route.params.id,
        this.formAsset.id,
      )
      instance
        .post(url, {
          description: this.formAsset.description,
        })
        .then(response => {})
        .catch(err => {
          this.loaderClone = false
          this.closable = true
          errorService(err)
        })
    },
    // Asset Section End //

    // Asset Link Section Start //
    openLinkData(data) {
      this.linkAssetDetails = data
      this.visible = true
    },

    linkUnlinkAsset(record) {
      this.loading = true
      const msg = 'Please wait while unlinking the asset'
      this.$root.$emit('popupUpdation', true, true, msg)
      const url = projectAPIs.project.asset.link.unlink(
        this.$route.params.id,
        record.linkedAssetId,
        record.id,
      )
      instance
        .patch(url)
        .then(response => {
          showNotification('info', 'Unlink Asset', response.data.message)
        })
        .catch(err => {
          this.loading = false
          errorService(err)
        })
    },

    onCancel(flag) {
      this.visible = false
      if (flag) {
        this.getAssets()
      }
    },
    // Asset Link Section End //

    // Common Method Start //
    isNumber(evt) {
      const splitNumber = this.form.zipcode
      if (splitNumber && splitNumber.length > 9) {
        evt.preventDefault()
      } else {
        return true
      }
    },

    onChange($event) {
      this.close = !this.close
      this.height = calculateHeight('projectDetailsTable', true)
      this.cardHeight = calculateHeight('projectDetails', true)
      if (this.close) {
        this.height = Number(this.height.split('px')[0]) + 224 + 'px'
      } else {
        this.height = Number(this.height.split('px')[0]) - 206 + 'px'
      }
      this.$root.$emit('onChange', this.close)
    },

    handleCancel() {
      this.loaderClone = false
      this.closable = true
      this.visibleClone = false
      this.visibleAsset = false
    },

    setActiveCell(key, index, value, record) {
      switch (key) {
        case 'assetNumber':
          this.gridOptions.api.setFocusedCell(index, 'analysisType')
          this.gridOptions.api.startEditingCell({
            rowIndex: index,
            colKey: 'analysisType',
          })
          break
        case 'analysisType':
          this.gridOptions.api.setFocusedCell(index, 'structureProfile')
          this.gridOptions.api.startEditingCell({
            rowIndex: index,
            colKey: 'structureProfile',
          })
          this.$root.$emit('updateNavigation', this.data)
          break
        case 'structureProfile':
          this.gridOptions.api.setFocusedCell(index, 'buildingUse')
          this.gridOptions.api.startEditingCell({
            rowIndex: index,
            colKey: 'buildingUse',
          })
          break
        case 'buildingUse':
          this.gridOptions.api.setFocusedCell(index, 'template')
          this.gridOptions.api.startEditingCell({
            rowIndex: index,
            colKey: 'template',
          })
          break
        case 'template':
          this.gridOptions.api.setFocusedCell(index, 'description')
          this.gridOptions.api.startEditingCell({
            rowIndex: index,
            colKey: 'description',
          })
          break
        case 'description':
          this.gridOptions.api.setFocusedCell(index, 'sf')
          this.gridOptions.api.startEditingCell({
            rowIndex: index,
            colKey: 'sf',
          })
          this.$root.$emit('updateAssetNameSidebar', key, value, record)
          break
        case 'sf':
          this.gridOptions.api.setFocusedCell(index, 'pis')
          this.gridOptions.api.startEditingCell({
            rowIndex: index,
            colKey: 'pis',
          })
          break
        case 'pis':
          this.gridOptions.api.setFocusedCell(index, 'costBasis')
          this.gridOptions.api.startEditingCell({
            rowIndex: index,
            colKey: 'costBasis',
          })
          this.loadingTable = false
          break
        case 'costBasis':
          if (index !== this.data.length - 1) {
            this.gridOptions.api.setFocusedCell(index + 1, 'assetNumber')
            this.gridOptions.api.startEditingCell({
              rowIndex: index + 1,
              colKey: 'assetNumber',
            })
          }
          break
        default:
          break
      }
    },

    resetRowData(index) {
      const newData = [...this.data]
      newData[index] = this.projectDetails
      this.data = [...newData]
      this.gridOptions.api.redrawRows()
      const itemsToUpdate = updateGridRecord(
        this.gridOptions,
        this.projectDetails,
        newData[index],
      )
      this.gridOptions.api.applyTransaction({
        update: itemsToUpdate,
      })
      this.gridOptions.api.redrawRows()
      const focusedCell = this.gridOptions.api.getFocusedCell()
      if (focusedCell) {
        this.gridOptions.api.setFocusedCell(
          focusedCell.rowIndex,
          focusedCell.column.colId,
        )
        this.gridOptions.api.startEditingCell({
          rowIndex: focusedCell.rowIndex,
          colKey: focusedCell.column.colId,
        })
      }
      this.projectDetails = null
    },

    checkNumber(event) {
      const keyCode = event.keyCode
      if (keyCode >= 48 && keyCode <= 57) {
        return true
      } else {
        event.preventDefault()
      }
    },
    // Common Method End //

    // Socket Section Start //
    messageReceived: function(message) {
      this.$notification.destroy()
      const data = JSON.parse(message.message)
      if (data.EventType === socketEvents.templateIntegrated) {
        this.$root.$emit('popupUpdation', false, true, null)
      } else if (data.EventType === socketEvents.syncProjectDetails) {
        if (data.Status === 'ERROR') {
          showNotification('error', 'Socket', data.Result.Message)
        } else {
          if (data.Result) {
            this.updateSyncProject(data.Result)
          }
        }
      } else if (data.EventType === socketEvents.projectAssetCloned) {
        this.loaderClone = false
        this.visibleClone = false
        this.closable = true
        this.getAssets()
      } else if (data.EventType === socketEvents.assetTakeOffUpdated) {
        this.closable = true
        this.loadingLinkTable = false
        this.$notification.success({
          message: 'Data Updated',
          description: h => (
            <div>
              <div>Data Updated successfully!</div>
            </div>
          ),
          duration: 200,
        })
      } else if (data.EventType === socketEvents.assetDetailsLinked) {
        if (this.isUnlink) {
          this.$root.$emit('popupUpdation', false, true, null)
          this.isUnlink = false
          this.linkIndex = 0
          const newData = [...this.data]
          newData[this.linkIndex].link = null
          newData[this.linkIndex].linkedAssetId = null
          this.data = newData
          this.getAssets()
        } else {
          this.closable = true
          const assetData = this.linkData.find(
            i => i.id === this.parentAssetId,
          )
          this.getAssetLinkData(assetData, undefined)
        }
      } else if (data.EventType === socketEvents.assetSaveAsTemplate) {
        if (data.Status === 'SUCCESS') {
          showNotification(
            'success',
            'Socket',
            'Template has been created successfully!',
          )
          this.handleCancel()
        } else {
          showNotification(
            'error',
            'Socket',
            'There was an error while creating template!',
          )
          this.loaderClone = false
        }
      } else if (data.EventType === socketEvents.error) {
        this.loaderClone = false
        this.loadingLinkTable = false
        this.closable = true
        this.$root.$emit('popupUpdation', false, true, null)
        showNotification('error', 'Socket', data.Result.Message)
      } else if (checkLinkAssetEvents(data.EventType)) {
        if (this.visible) {
          this.$root.$emit('message-received', message)
        } else {
          this.$root.$emit('popupUpdation', false, true, null)
          this.getAssets()
        }
      }
      if (checkAssetDetailsEvents(data.EventType)) {
        this.$root.$emit('popupUpdation', false, true, null)
      } else if (data.EventType === socketEvents.projectAssetDeleted) {
        this.$root.$emit('popupUpdation', false, true, null)
      }
    },
    // Socket Section End //

    getColumnSettings(params) {
      params.api.setColumnDefs(this.columns)
      const columnDetails = this.columnSettings.find(
        i => i.screenId === 1 && i.tableName === tableName.project.asset,
      )
      if (columnDetails && columnDetails.columnDetails) {
        const tableState = JSON.parse(columnDetails.columnDetails)
        this.gridOptions.columnApi.applyColumnState({
          state: tableState,
          applyOrder: true,
        })
      } else {
        if (params) {
          params.api.sizeColumnsToFit()
        }
      }
      if (this.isArchive) {
        this.gridOptions.columnApi.applyColumnState({
          state: [
            {
              colId: 'checkbox',
              hide: this.isArchive,
            },
            {
              colId: 'action',
              hide: this.isArchive,
            },
          ],
        })
        if (params) {
          params.api.sizeColumnsToFit()
        }
      }
    },

    updateColumnSetting() {
      const tableState = this.gridOptions.columnApi.getColumnState()
      const request = {
        screenId: 1,
        tableName: tableName.project.asset,
        columnDetails: JSON.stringify(tableState),
      }
      if (!this.isArchive) {
        this.$emit('updateColumnSettings', request)
      }
    },

    sortChanged(value) {
      this.updateColumnSetting()
    },

    onColumnResized(e) {
      if (e.finished) {
        this.updateColumnSetting()
      }
    },
  },
}
